import { Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { SharedService } from 'app/shared/service/shared.service';
import { MenuAccessServiceProxy } from 'shared/service-proxies/services/menu-access.service';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit {
    // Private
    _variant: string;
    roleId: number;

    /**
     * Constructor
     *
     * @param {ElementRef} _elementRef
     * @param {Renderer2} _renderer
     */
    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2,
        private _menuAccessServiceProxy: MenuAccessServiceProxy,
        private _authenticationService: AuthenticationService,
        private _sharedService: SharedService
    ) {
        // Set the private defaults
        this._variant = 'vertical-style-1';
    }
    ngOnInit(): void {
        //this.getRoleWiseWright();

    }
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string {
        return this._variant;
    }

    @Input()
    set variant(value: string) {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }
    // getRoleWiseWright() {

    //     this.roleId = this._authenticationService.CurrentUserRoleId();
    //     this._menuAccessServiceProxy.getRolewiseMenuWrightsAssign(this.roleId).subscribe(response => {
    //         if (response.isSuccess) {
    //             this._sharedService.menuAccessWright = response.responseData;
    //         }
    //     })

    // }
    
}
